
const SUBSCRIPTION_TEXT_PATTERNS = [
  /this item is a deferred, subscription, or recurring purchase/i,
  /authorize you to charge my payment method/i,
  /until my order is fulfilled or i cancel/i,
  /subscription/i,
  /recurring purchase/i,
  /selling plan/i,
  /purchase options/i,
  /delivery every/i,
  /auto-?renew/i,
];

function matchesSubscriptionText(text) {
  const normalized = (text || '').replace(/\s+/g, ' ').trim();
  return SUBSCRIPTION_TEXT_PATTERNS.some((pattern) => pattern.test(normalized));
}

function removeMatchingNodes(root = document) {
  const selectors = [
    'shopify-payment-terms',
    '.shopify-payment-terms',
    '[data-shopify-payment-terms]',
    '.installments',
    'form.payment-terms',
    '[class*="subscription"]',
    '[id*="subscription"]',
    '[class*="selling-plan"]',
    '[id*="selling-plan"]',
    '[data-selling-plan-group]',
    '[data-purchase-option]',
    '[data-subscriptions-widget]',
    'input[name="selling_plan"]',
    'input[name="selling_plan_group"]'
  ];

  root.querySelectorAll(selectors.join(','))?.forEach((node) => {
    if (node.matches('input')) {
      node.remove();
      return;
    }
    node.remove();
  });

  root.querySelectorAll('p, div, span, small, label')?.forEach((node) => {
    if (!node.children.length && matchesSubscriptionText(node.textContent)) {
      node.remove();
    }
  });
}

function runCleanup() {
  removeMatchingNodes(document);
  document.querySelectorAll('form[action*="/cart/add"]')?.forEach((form) => {
    form.querySelectorAll('input[name="selling_plan"], input[name="selling_plan_group"]')?.forEach((input) => input.remove());
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runCleanup, { once: true });
} else {
  runCleanup();
}

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== Node.ELEMENT_NODE) continue;
      removeMatchingNodes(node);
      if (matchesSubscriptionText(node.textContent)) {
        node.remove();
      }
    }
  }
});

observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
});

window.addEventListener('shopify:section:load', runCleanup);
document.addEventListener('variant:change', runCleanup);
document.addEventListener('change', (event) => {
  const target = event.target;
  if (target instanceof HTMLInputElement || target instanceof HTMLSelectElement) {
    if (target.name === 'id' || target.name === 'selling_plan' || target.name === 'selling_plan_group') {
      queueMicrotask(runCleanup);
    }
  }
});
